<template>
    <div>
        <PageTitle :title="$t('renovar_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" class="strech"/>
        <template v-if="! isLfp">
            <RenovarAbono />
        </template>
        <template v-else>
            <RenovarAbonoLfp/>
        </template>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import RenovarAbono from '@/components/frontend/abonos/renovar/RenovarAbono.vue';
    import RenovarAbonoLfp from '@/components/frontend/abonos/renovar/RenovarAbonoLfp.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        components: {
            PageTitle,
            RenovarAbono,
            RenovarAbonoLfp
        },
        created() {
            useHead('Renovación de abonos');

            let super_hiper_acceso = this.$route.query.super_hiper_acceso

            if(!this.footer.renovar_abono && !(super_hiper_acceso === "si")) {
                this.$router.push({ name: 'front.home'});
            }
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            isLfp() {
                return this.$store.getters.getFooter.lfp;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            }
        }
    }
</script>